import { styled, css } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import { createTransition } from '../utilities/create-transition.js';
import { createElement } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Input as Input$2 } from '@vebox/etui-system-elements';
import { darken } from '@vebox/etui-colors';

const _excluded = ["theme", "startInputAddon", "endInputAddon", "disabled", "label", "readOnly", "size", "borderColor", "error"];
const Input = styled(Input$2).attrs(_ref => {
  let {
      theme,
      startInputAddon,
      endInputAddon,
      disabled,
      label,
      readOnly,
      size,
      borderColor,
      error
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const defaultBorderColor = theme.palette.grey[60];
  const activeBorderColor = theme.palette.grey[100];
  const errorColor = theme.palette.error.main;
  const disabledBorderColor = darken(theme.palette.action.disabledBackground, 0.1);
  const isBorderColorOverriding = borderColor ? borderColor !== defaultBorderColor : false;
  const isErrorBorderColor = error ? errorColor : defaultBorderColor;
  return _objectSpread2({
    display: 'block',
    width: '100%',
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: [theme.typography.pxToRem(16), theme.typography.pxToRem(16), theme.typography.pxToRem(14)],
    color: error ? errorColor : theme.palette.text.primary,
    bg: disabled ? theme.palette.action.disabledBackground : theme.palette.common.white,
    borderRadius: theme.shape.borderRadius,
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: disabled ? disabledBorderColor : isBorderColorOverriding ? borderColor : defaultBorderColor ? isErrorBorderColor : errorColor,
    height: size === 'default' ? theme.shape.inputHeight : theme.shape.inputHeightSmall,
    pt: label ? `${size === 'default' ? theme.spacing.xlg : theme.spacing.lg - 2}px` : `${theme.spacing.xs}px`,
    pl: startInputAddon !== undefined ? `calc(${theme.spacing.xs + 24 + theme.spacing.xs}px)` : `${theme.spacing.xs}px`,
    pr: endInputAddon !== undefined ? `calc(${theme.spacing.xs + 24 + theme.spacing.xs}px)` : `${theme.spacing.xs}px`,
    pb: label ? `${size === 'default' ? theme.spacing.xs : theme.spacing.xxs}px` : `${theme.spacing.xs}px`,
    outline: 0,
    cursor: disabled ? 'not-allowed' : 'auto',
    boxShadow: disabled || readOnly ? 'none' : 'unset',
    hoverBorderColor: disabled ? disabledBorderColor : isBorderColorOverriding ? borderColor : activeBorderColor ? isErrorBorderColor : errorColor,
    hoverBoxShadow: '0px 0px 4px -1px rgba(0, 0, 0, 0.12), 0px 0px 4px 0px rgba(0, 0, 0, 0.08),0px 1px 10px 0px rgba(0, 0, 0, 0.06)',
    transition: createTransition(['border-color', 'box-shadow'], {
      duration: 'shorter'
    })
  }, rest);
})`
  ${({
  disabled,
  readOnly,
  hoverBorderColor,
  hoverBoxShadow
}) => {
  if (!disabled || !readOnly) {
    return css`
        &:hover {
          border-color: ${hoverBorderColor};
        }

        &:focus {
          border-color: ${hoverBorderColor};
          box-shadow: ${hoverBoxShadow};
        }
      `;
  }
  return ``;
}};
`;

const _excluded$1 = ["size"];
function Input$1(_ref) {
  let {
      size = 'default'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded$1);
  return /*#__PURE__*/createElement(Input, _extends({
    size: size
  }, props));
}

export default Input$1;
